import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Group = ({className, compactView, dispatch, ...props}) => (
  <div
    className={classNames('form-group', {'form-group--small': compactView}, className)}
    {...props}
  />
);

Group.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  compactView: PropTypes.bool.isRequired,
  dispatch: PropTypes.func
};

function mapStateToProps(state) {
  return {
    compactView: state.xl.compactView
  };
}

export default connect(mapStateToProps)(Group);



// WEBPACK FOOTER //
// ./components/Form/Group.jsx